import React, { Component } from 'react';
import './DailyView.css';
import axios from 'axios';
import 'react-table/react-table.css';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import * as appsettings from './constants';
import { authContext } from '../adalConfig';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import './Modal.css';
import queryString from 'query-string';
import DateTime from 'react-datetime';
import './react-datetime.css';
const customStyles = {
    content: {
        top: '60%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        height: '450px',
        width: '500px',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
export class CommentView extends Component {
    displayName = CommentView.name
    constructor(props) {
        super(props);
        this.today = new Date();
        this.exceptionDate = new Date();
        this.exceptionDate.setUTCFullYear(1950);
        this.today.setDate(this.today.getDate() - 31);
        this.today.setHours(5);
        this.today.setMinutes(30);
        this.today.setSeconds(0);
        this.tomorrow = new Date();
        this.tomorrow.setDate(this.tomorrow.getDate());
        this.tomorrow.setHours(5);
        this.tomorrow.setMinutes(30);
        this.tomorrow.setSeconds(0);
        this.state = {
            Metric: [], loading: false, userId: '', selected: -1, deleteButton: true,
            modalIsOpen: false,
            PortalNameList: [], Component: "Select Component",
            metricType: "Select Metric Type",
            isRisk: true,
            fromDate: this.today.toISOString(), toDate: this.tomorrow.toISOString(),
            exceptionDate: this.exceptionDate.toISOString()
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
    componentDidMount() {
        var user = authContext.getCachedUser();
        var userId = user.userName;
        var domainIndex = userId.indexOf('@microsoft.com');
        userId = userId.substr(0, domainIndex);
        this.setState({
            userId: userId
        })
        appsettings.SelectedRow[0].value = -1;
        this.getData();
    }
    openModal() {
        this.getPortalNamesData();
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }
    getPortalNamesData() {
        var apilink = "api/CosmosApi/GetPortalNames/";
        const token = authContext.getCachedToken(authContext.config.clientId);
        axios.get(apilink,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            this.setState({
                PortalNameList: response.data.sort()
            })
        });
    }
    onSelectPortalName(event) {
        this.setState({
            Component: event.value
        })
    }
    toggleChange() {
            this.setState({
                isRisk: !this.state.isRisk
            })
        
    }
    onSelectMetricType(event) {
        this.setState({
            metricType: event.value
        })
    }
    updateFromDate(date) {
        try {
            this.setState({
                fromDate: date._d.toISOString()
            });
        }
        catch (err) {
            this.setState({
                fromDate: this.state.exceptionDate,
                toDate: this.state.exceptionDate
            });

        }
    }
    updateToDate(date) {
        try {
            this.setState({
                toDate: date._d.toISOString()
            });
        }
        catch (err) {
            this.setState({
                fromDate: this.state.exceptionDate,
                toDate: this.state.exceptionDate
            });
        }
    }
    submitComment() {
        var comment = ReactDOM.findDOMNode(this.refs.InputComment).value;
        if (this.state.Component === 'Select Component')
            alert('Please select a component');
        else if (this.state.metricType === 'Select Metric Type')
            alert('Please select a metric Type');
        else {
            var apilink = "api/CosmosApi/GetAddComment/?portalName="
                + this.state.Component + "&metricType=" + this.state.metricType + "&fromDate=" + this.state.fromDate + "&toDate=" + this.state.toDate + "&alias=" + this.state.userId + "&comment=" + comment + "&isRisk=" + this.state.isRisk;
            const token = authContext.getCachedToken(authContext.config.clientId);
            axios.post(apilink, null,
                {
                    headers: {
                        Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                    }
                }).then(response => {
                    if (response.data === true || response.data === 'true') {
                        alert('Comment added successfully');
                        this.closeModal();
                        this.getData();
                    } else {
                        alert('Comment was NOT saved. Backend response: ' + JSON.stringify(response.data));
                    }
                }).catch(error => {
                    const detail = error.response
                        ? (error.response.status + ': ' + JSON.stringify(error.response.data))
                        : error.message;
                    alert('Failed to add comment. ' + detail);
                });
        }

    }
    getData() {
        this.setState({
            loading: true
        });
        var Name;
        if (this.props.location.search === '')
            Name = "All";
        else {
            const values = queryString.parse(this.props.location.search);
            console.log(values.ServiceName);
            Name = values.ServiceName;

        }
        var apilink = "api/CosmosApi/GetComments?StartTime='" + this.state.fromDate + "'&endTime='" + this.state.toDate + "'&ServiceName=" + Name;
        const token = authContext.getCachedToken(authContext.config.clientId);
        axios.get(apilink,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            this.setState({
                loading: false,
                Metric: response.data
            });
        });
    }
    onRowSelection(index) {
        this.setState({
            selected: index,
            deleteButton: false
        })
    }
    deleteComment() {
        var index = this.state.selected;
        if (index === -1)
            alert('Select a row by clicking on it');
        else {
            var alias = (this.state.Metric[index].alias || '').trim();
            if (alias.endsWith('@microsoft.com')) {
                alias = alias.substring(0, alias.length - '@microsoft.com'.length);
            }

            if (alias !== this.state.userId)
                alert('You are not authorized to delete the comment');
            else {
                var apilink =  "api/CosmosApi/GetdeleteComment/?id=" + this.state.Metric[index].identifier + "&timestamp=" + this.state.Metric[index].timestamp + "&alias=" + this.state.userId;
                const token = authContext.getCachedToken(authContext.config.clientId);
                axios.delete(apilink,
                    {
                        headers: {
                            Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                        }
                    }).then(response => {
                });
                this.getData();
            }
        }
    }

    editComment() { }
    openHelp() {
        const url = appsettings.HelpPageRootURL;
        const w = window.open(url, '_blank', 'noopener,noreferrer');
        if (w != null) {
            w.opener = null;
        } else {
            window.location.href = url;
        }
    }
    render() {
        const metricTypes = ['Reliability', 'Availability', 'Performance'];
        return (
            <div>
                <div id="banner">
                    <h4 id="header">{appsettings.CommentViewHeader}</h4>
                </div>
                <div style={{ height: '8%', width: '100%', display: 'inline-flex', marginTop: '-3%' }}>
                    <div id='starttime'>Start Time:</div>
                    <DateTime className='FromDate' closeOnSelect={true} onBlur={this.updateFromDate.bind(this)} utc={true} defaultValue={this.today} />
                    <div id='endtime'>End Time:</div>
                    <DateTime className='ToDate' closeOnSelect={true} onBlur={this.updateToDate.bind(this)} utc={true} defaultValue={this.tomorrow} />
                    <button id='GetKPIsButton' onClick={this.getData.bind(this)} data-tooltip="Fetch Comments">Fetch</button>
                    {/* Changed: use anchor to always open in a new tab */}
                    <a
                        id='HelpButton'
                        href={appsettings.HelpPageRootURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="ECTelemetry Wiki"
                        aria-label="ECTelemetry Wiki"
                        style={{ marginLeft: '10px' }}
                    >
                        ECTelemetry Wiki
                    </a>
                </div>
                <hr />

                <p id='target'>Target : Availability: >={appsettings.AvailabilityGreenTarget}%, Reliability:>={appsettings.ReliabilityGreenTarget}%, Performance: >={appsettings.PerformanceGreenTarget}%</p>
                <div className="AddComment" style={{ display: 'inline-flex' }}>
                    <div>
                        <button onClick={this.openModal}>Add Comment</button>
                        <Modal
                            isOpen={this.state.modalIsOpen}
                            onRequestClose={this.closeModal}
                            style={customStyles}
                            ariaHideApp={false}
                            contentLabel="Example Modal"
                        >
                            <h2 className="header">Add Comment</h2>
                            <Dropdown className="CommentDropdown" onChange={this.onSelectPortalName.bind(this)} options={this.state.PortalNameList} value={this.state.Component} />
                            <Dropdown className="CommentDropdown" onChange={this.onSelectMetricType.bind(this)} options={metricTypes} value={this.state.metricType} />
                            "isRisk": <input type="checkbox" defaultChecked={this.state.isRisk} onChange={this.toggleChange.bind(this)} />
                            <div style={{ display: 'inline-flex', marginLeft: '15px', marginTop: '5px', width: '100%' }}>
                                <div style={{ marginTop: '5px', marginRight: '2%' }}>Start:</div><DateTime closeOnSelect={true} onBlur={this.updateFromDate.bind(this)} utc={true} defaultValue={this.today} />
                                <div style={{ marginTop: '5px', marginRight: '2%' }}>End:</div><DateTime closeOnSelect={true} onBlur={this.updateToDate.bind(this)} utc={true} defaultValue={this.tomorrow} />
                            </div>
                            <textarea className="CommentTextInput" ref="InputComment" type="text" placeholder="Type Comment Here" />
                            <button className="CommentSubmit" onClick={this.submitComment.bind(this)}>Submit</button>
                        </Modal>
                    </div>
                    <button disabled={this.state.deleteButton} style={{ marginLeft: '5px' }} onClick={this.deleteComment.bind(this)} >Delete Comment</button>
                </div>

                <ReactTable
                    data={this.state.Metric}
                    columns={appsettings.Commentcolumns}
                    minRows={0}
                    maxRows={500}
                    defaultPageSize={100}
                    showPagination={true}
                    sortable={true}
                    filterable={true}
                    loading={this.state.loading}
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    style={{
                        borderStyle: 'solid',
                        borderWidth: "1px",
                        overflow: "hidden",
                    }}
                    className="-striped "
                    getTdProps={() => {
                        return {
                            style: {
                                borderColor: "#f7f7f7",
                                textAlign: 'center',
                                fontSize: '12px',
                                padding: '1px',
                                borderWidth: '1px',
                                wordWrap: 'break-word',
                                whiteSpace: 'pre-wrap'
                            }
                        };
                    }}

                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                            return {
                                onDoubleClick: (e) => {
                                },
                                onClick: (e) => {
                                    this.onRowSelection(rowInfo.index);
                                },
                                style: {
                                    background: rowInfo.index === this.state.selected ? '#96B1C7' : ''
                                }
                            }
                        } else {
                            return {}
                        }
                    }
                    }


                    getTheadThProps={() => {
                        return {
                            style: {
                                background: "#f7f7f7",
                                borderColor: "#f7f7f7",
                                color: 'black',
                                textAlign: 'left',
                                fontSize: '14px',
                                height: '30px',
                                fontWeight: 'bold'
                            }
                        };
                    }}

                />

            </div>
        );
    }
}
